import GetData from "@/utils/request.js"

const {
  $get,
  $post
} = new GetData();


// 判断是否会员
export const isMemberVip= () => {
  return $get('/h5/membervip/isMemberVip' );
}
// 会员权益列表
export const getMemberInterestlist = () => {
 return $get('/h5/membervip/getMemberInterestlist' );
}

// 会员商品详情(新)
export const getMemberInfo = () => {
 return $get('/h5/membervip/getMemberInfo' );
}
// 获取单个权益活动详情
export const getMembernterestAction = (id) => {
 return $get('/h5/membervip/getMembernterestAction?interestId='+id );
}
// 会员报名活动
export const signUpterestAction = (data) => {
 return $get('/h5/membervip/signUpterestAction',data);
}

// 可用优惠券列表
export const usageCouponList = (data) => {
 return $get('/h5/coupon/usageCouponList',data);
}

// 获取对公支付信息
export const getCorporatePayment = (id) => {
 return $get('/h5/order/getCorporatePaymentInfo?orderNo='+id);
}


export default {
	isMemberVip,
  getMemberInterestlist,
  getMemberInfo,
  getMembernterestAction,
  signUpterestAction,
  usageCouponList,
  getCorporatePayment
  
  

}
